module.exports = __webpack_public_path__ + "img/bulb.a927161a.svg";